const cache = state => state.cache
const stream = state => state.stream
const purging = state => state.purging
const progress = state => state.progress

export default {
  cache,
  stream,
  purging,
  progress
}
